<template lang="html">
<div class="container">
  <div :class="wrapClasses">
    <div class="content">
      <div class="Document">
        <div class="Document-icon">
          <icon name="file-text-o"></icon>
        </div>
        <div class="Document-text">
          <div v-if="document.file || document.url">
            <a :href="document.url || document.file.asset" target="_blank">
              <h4>{{document.title}}</h4>
            </a>
            <p class="Document-description">{{document.description}}</p>
          </div>
          <h4 v-else>Dokumentet er slettet</h4>
        </div>
      </div>
    </div>
  </div>
</div>

</template>

<script>
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/file-text-o'

export default {
  props: ['document', 'wrapClasses'],
  components: {
    Icon
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/DocumentRef.vue